module.exports = __webpack_public_path__ + "assets/img/2.ca9937d7.png";